import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardCommissionsInvoicesRow from './DashboardCommissionsInvoicesRow/DashboardCommissionsInvoicesRow';
import { useCommissionsInvoices } from '../../../../../hooks/fetchers/useCommissionsInvoices/useCommissionsInvoices';
import { useBoostsInvoices } from '../../../../../hooks/fetchers/useBoostsInvoices/useBoostsInvoices';
import { useEffect, useState } from 'react';
import { CommissionInvoice } from '../../../../../types/models/commission/commission.types';
import { useMergedStatesFromFetchers } from '../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers';
import Loading from '../../../../commons/Loading/Loading';

export default () => {
  
  const { data: commissionsInvoices, isLoading: isCommissionsInvoicesLoding } = useCommissionsInvoices();
  const { data: boostsInvoices, isLoading: isBoostsInvoicesLoding } = useBoostsInvoices();

  const [mergedInvoices, setMergedInvoices] = useState<CommissionInvoice[]>()

  useEffect(() => {
    const concat = [...(commissionsInvoices || []), ...(boostsInvoices || [])]
    const properlyMerged = concat
      .reduce(
        (acc, item) => {
          const commissionAmount = commissionsInvoices?.find(invoice => invoice.month === item.month && invoice.year === item.year)?.total_amount || 0
          const boostAmount = boostsInvoices?.find(invoice => invoice.month === item.month && invoice.year === item.year)?.total_amount || 0
          
          if (!(acc as CommissionInvoice[]).find(row => row.month === item.month && row.year === item.year)) {
            return [
              ...acc,
              {
                ...item,
                total_amount: commissionAmount + boostAmount
              }
            ]
          } else {
            return acc
          }
        },
        [] as CommissionInvoice[]
      )
      .sort(( a, b ) => {
        if ( a.month > b.month ){
          return -1;
        }
        if ( a.month < b.month ){
          return 1;
        }
        return 0;
      })
      .sort(( a, b ) => {
        if ( a.year > b.year ){
          return -1;
        }
        if ( a.year < b.year ){
          return 1;
        }
        return 0;
      })
    if (commissionsInvoices && boostsInvoices) {
      setMergedInvoices(properlyMerged)
    }
  }, [commissionsInvoices, boostsInvoices])

  const { isLoading } = useMergedStatesFromFetchers({ loadings: [isCommissionsInvoicesLoding, isBoostsInvoicesLoding] })

  if (isLoading) return <Loading />

  return (
    <DashboardLayout>
      <table className="dashboard__table dashboard-invoices__table">
        <colgroup>
          <col style={{ width: '70%' }} />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>Mois</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {mergedInvoices?.map((commissionInvoice, commissionInvoiceIndex) => {
            return (
              <DashboardCommissionsInvoicesRow
                key={commissionInvoiceIndex}
                className={
                  commissionInvoiceIndex === 0
                    ? 'dashboard-invoices__table-row dashboard-invoices__table-row--active'
                    : 'dashboard-invoices__table-row'
                }
                {...{ commissionInvoice, boostsInvoices }}
              />
            );
          })}
        </tbody>
      </table>
    </DashboardLayout>
  );
};
